import { AdminMembersReportProductsTableToolbarState } from "@/admin/insights/member-reports/tabs/products/AdminMembersReportProductsTable"
import DiscoTableFilterTags from "@disco-ui/table/header/filter/DiscoTableFilterTags"
import DiscoTag from "@disco-ui/tag/DiscoTag"
import { TestIDProps } from "@utils/typeUtils"

interface Props extends TestIDProps {
  toolbarState: Partial<AdminMembersReportProductsTableToolbarState>
  setToolbarState: React.Dispatch<
    React.SetStateAction<Partial<AdminMembersReportProductsTableToolbarState>>
  >
}

function AdminMembersReportProductsTableFilterTags({
  testid = "AdminMembersReportProductsTableFilterTags",
  toolbarState,
  setToolbarState,
}: Props) {
  const { curriculumCompletion } = toolbarState
  const showFilterTags = Boolean(curriculumCompletion)

  return (
    <DiscoTableFilterTags isVisible={showFilterTags}>
      {toolbarState.curriculumCompletion && (
        <DiscoTag
          testid={`${testid}.filter-tag.curriculum-completion`}
          name={toolbarState.curriculumCompletion.title}
          onDelete={() => {
            setToolbarState({
              ...toolbarState,
              curriculumCompletion: null,
            })
          }}
        />
      )}
    </DiscoTableFilterTags>
  )
}

export default AdminMembersReportProductsTableFilterTags
